import React from "react";
import MasterList from "../../components/MasterList";
import RequestTypeList from "../../components/RequestTypeList";
import SettingsSection from "./SettingsSection";
import { reorderMasters } from "../../lib/api";

export default function MastersPanel() {
  return (
    <SettingsSection title="Masters" description="Manage the request types, categories, priorities, impact levels and project types available across the workspace.">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <RequestTypeList />
        <MasterList title="Categories" listPath="/masters/category" itemPath={(id) => `/masters/category/${id}`} onReorder={(ids) => reorderMasters("category", ids)} />
        <MasterList title="Priorities" listPath="/masters/priority" itemPath={(id) => `/masters/priority/${id}`} onReorder={(ids) => reorderMasters("priority", ids)} />
        <MasterList title="Impact levels" listPath="/masters/impact" itemPath={(id) => `/masters/impact/${id}`} onReorder={(ids) => reorderMasters("impact", ids)} />
        <MasterList title="Project Types" listPath="/masters/project_type" itemPath={(id) => `/masters/project_type/${id}`} onReorder={(ids) => reorderMasters("project_type", ids)} />
      </div>
    </SettingsSection>
  );
}
